import React from 'react'
import { Button, Flex, Grid } from '@chatterbug/aaron'
import { usePageParams } from 'src/utils/params'
import routes from 'lib/rails-routes/rails-routes'
import { t } from 'lib/i18n-react'

export type Props = {
  primaryActionSection?: JSX.Element
  secondaryActionSection?: JSX.Element
}

const PageWrapupActions: React.FC<Props> = ({
  primaryActionSection,
  secondaryActionSection,
}) => {
  const { l2Code } = usePageParams()

  return (
    <Flex justifyContent="center">
      <Grid
        columns={{
          _: '1fr',
          mobile: `repeat(${
            primaryActionSection && secondaryActionSection ? 2 : 1
          }, 1fr)`,
        }}
        gap="2x"
      >
        {!primaryActionSection && !secondaryActionSection && (
          // fallback
          <Button
            type="primaryAdvanced"
            href={routes.home_student({ code: l2Code })}
          >
            {t('Back to Home')}
          </Button>
        )}
        {secondaryActionSection}
        {primaryActionSection}
      </Grid>
    </Flex>
  )
}

export default PageWrapupActions
